// Generated code for Big.Entities.BetalingsStatus.
// Edit _Enum.tst to change the generated output.

export enum BetalingsStatus {
    wachtOpUpdate = 0,
    geannuleerd = 1,
    gefaald = 2,
    geslaagd = 9,
    geslaagdHandmatig = 999
}
(BetalingsStatus as any).name = 'BetalingsStatus';
